import { _types } from './constant'
import api from '@/api'

const state = {
    overview: null,
    settingsTheme: null,
    autoSettings: null,
    optimizeProcess: null,
    newOptimize: null
};

const getters = {
    [_types.getters.GET_OVER_VIEW](state){
        return state.overview
    },
    [_types.getters.GET_SETTINGS_THEME](state){
        return state.settingsTheme
    },
    [_types.getters.GET_AUTO_SETTINGS](state){
        return state.autoSettings
    },
    [_types.getters.GET_OPTIMIZE_PROCESS](state){
        return state.optimizeProcess
    },
    [_types.getters.GET_NEW_OPTIMIZE](state){
        return state.newOptimize
    }
};

const actions = {
    async [_types.actions.OPTIMIZE]({}, payload){
        try {
            return await api.optimize(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_COMPRESS_IMAGES_BY_LOG]({}, payload){
        try {
            return await api.getImgsCompressedByLog(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_DETAIL_IMAGE]({}, payload){
        try {
            return await api.getDetailImage(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.RESTORE_IMAGE]({}, payload){
        try {
            return await api.restoreImage(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_TOTAL_IMAGES]({}, payload){
        try {
            return await api.getTotalImages(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_ALL_LOGS]({}, payload){
        try {
            return await api.getAllLogs(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_OVER_VIEW]({commit}, payload){
        try {
            let res = await api.getOverview(payload);
            let { status = false, data = null } = res.data
            if( status ){
                commit(_types.mutations.SET_OVER_VIEW, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.START_OPTIMIZE]({}, payload){
        try {
            return await api.startOptimize(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_LOG_DETAIL]({}, payload){
        try {
            return await api.getLogDetail(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.HIDE_CONFIRM_RESTORE]({}, payload){
        try {
            return await api.hideConfirmRestore(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.STOP_OPTIMIZE_IMAGES]({}, payload){
        try {
            return await api.stopOptimizeImages(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.CHECK_NEW_OPTIMIZE]({commit}, payload){
        try {
            let res = await api.checkNewOptimize(payload);
            let { status = false, data = null } = res.data
            if ( status ) {
                commit(_types.mutations.SET_NEW_OPTIMIZE, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_SETTINGS_THEME]({commit}, payload){
        try {
            let res = await api.getSettingsTheme(payload);
            let { status = false, data = null } = res.data
            if( status ){
                commit(_types.mutations.SET_SETTINGS_THEME, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_PROCESS]({commit}, payload){
        try {
            let res = await api.getProcess(payload);
            let { status = false, data = null } = res.data
            if( status ){
                commit(_types.mutations.SET_OPTIMIZE_PROCESS, data.data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.STOP_OPTIMIZE_THEME]({}, payload){
        try {
            return await api.stopOptimizeTheme(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_THEME_BY_LOG]({}, payload){
        try {
            return await api.getThemeByLog(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.GET_AUTO_SETTINGS]({commit}, payload){
        try {
            let res = await api.getAutoSettings(payload);
            let { status = false, data = null } = res.data
            if( status ){
                commit(_types.mutations.SET_AUTO_SETTINGS, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.SAVE_AUTO_SETTINGS]({}, payload){
        try {
            return await api.saveAutoSettings(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.REMOVE_DUPLICATE_THEME]({}, payload){
        try {
            return await api.removeDuplicateTheme(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.PUBLISH_CHANGE]({}, payload){
        try {
            return await api.publishChange(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.REMOVE_CODE]({}, payload){
        try {
            return await api.removeCode(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.UPDATE_TOOLTIP]({}, payload){
        try {
            return await api.updateTooltip(payload);
        } catch (error) {
            throw error;
        }
    },
};

const mutations = {
    [_types.mutations.SET_OVER_VIEW](state , payload = null ){
        state.overview = payload
    },
    [_types.mutations.SET_SETTINGS_THEME](state , payload = null ){
        state.settingsTheme = payload
    },
    [_types.mutations.SET_AUTO_SETTINGS](state , payload = null ){
        state.autoSettings = payload
    },
    [_types.mutations.SET_OPTIMIZE_PROCESS](state , payload = null ){
        state.optimizeProcess = payload
    },[_types.mutations.SET_NEW_OPTIMIZE](state , payload = null ){
        state.newOptimize = payload
    }
};
export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};